/**
 * Helper for converting various possible error objects to a user friendly error message.
 */
export class ErrorResponse {
    /** default message return when specific message cannot be generated */
    static defaultErrorMessage = 'An error occurred. Please contact your system administrator for assistance.';
    /** user friendly message generated from input */
    message: string = ErrorResponse.defaultErrorMessage;
    /** original input, only set if input could not be parsed into a message */
    rawValue: any | undefined;

    /**
     * @param value - optional object containing error information
     */
    constructor(value?: any) {
        if (value?.errors && Array.isArray(value.errors)) {
            this.message = this.getErrorMessageFromArray(value.errors);
        } else if (Array.isArray(value)) {
            this.message = this.getErrorMessageFromArray(value);
        } else if (typeof value === 'string') {
            this.message = value;
        } else if (value?.ErrorMessage) {
            this.message = value.ErrorMessage;
        } else if (value && value.stack && value.message) {
            //duck typing check for Error type
            this.message = value.message;
        } else {
            this.rawValue = value;
        }
    }

    static DefaultErrorResponse() {
        return new ErrorResponse();
    }

    private getErrorMessageFromArray(errors: Array<any>): string {
        let message = '';
        if (errors.length > 0) {
            message = errors.map((i) => i.message).join(', ');
        }
        return message;
    }
}
